import { render, staticRenderFns } from "./molisMerchantMenuList.vue?vue&type=template&id=6fc17794&scoped=true"
import script from "./molisMerchantMenuList.vue?vue&type=script&lang=ts"
export * from "./molisMerchantMenuList.vue?vue&type=script&lang=ts"
import style0 from "./molisMerchantMenuList.vue?vue&type=style&index=0&id=6fc17794&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc17794",
  null
  
)

export default component.exports